import Resct from 'react';
import clsx from 'clsx';
import moment from 'moment';
import { useTranslation, Trans } from "react-i18next";
import React, { useCallback, useEffect, useState } from 'react';

import A from '../../common/A';
import { useUserInfo, useWorksheet } from '../../../hooks';
import { TYPE } from '../../../constant';

function StageItem({
  item,
  btnType,
  defaultAiMsgView,
  handleLearningBtn,
  setConceptPopup,
  stageListAPICall
}) {
  const { t } = useTranslation();
  const { handleWorkSheet } = useWorksheet();
  const { info } = useUserInfo();
  const [lastMsg, setLastMsg] = useState(true);
  const [videoMsg, setVideoMsg] = useState(true);
  const [worksheetMsg, setWorksheetMsg] = useState(true);
  const [aiMsg, setAiMag] = useState(defaultAiMsgView);

  useEffect(() => {
    if (item && item.lastStgYn === 'Y' && item.workSheetYn === 'N' && btnType === 'worksheet') {
      stageListAPICall('THMA_00', '2021')

      // 모바일, 테블릿에서 해당 대주제 코드로 이동
      const dom = document.getElementsByClassName("sl-header-list")[0].childNodes[0];
      document.getElementsByClassName('btn-tab-active')[0].className = ""

      setTimeout(() => {
        if (dom) {
          dom.childNodes.className = 'btn-tab-active'
          dom.scrollIntoView(true);
        }
      }, 200);
    }
  }, [])

  useEffect(() => {
    setAiMag(defaultAiMsgView);
  }, [defaultAiMsgView]);

  const handleClick = (e, item) => {
    console.log("***** 주제학습 - 개념확인 모달 오픈")
    e.preventDefault();
    if (btnType === 'video') setVideoMsg(false);

    setConceptPopup({ 
      url: item.cncpMeta, 
      title: item.stgNm, 
      stgCd: item.stgCd, 
      stepNm: item.stgNm,
      thmaNm: item.thmaNm,
      onOff: true 
    });
  };

  const handleMessage = (type) => {
    switch (type) {
      case 'last': setLastMsg(false); break;
      case 'ai': setAiMag(false); break;
      case 'video': setVideoMsg(false); break;
      case 'worksheet': setWorksheetMsg(false); break;
    }

  }

  return (
    <li
      id={clsx({
        lastStage: (item.lastStgYn === "Y" && lastMsg),
        aiStage: (item.lastStgYn !== "Y" && (item.bgnStgCd && aiMsg))
      })}
      className={clsx({
      defaultStage: item?.defaultStgCdYN === 'Y'
      })}
    >
      <A onClick={() => handleLearningBtn(item)}>
        <div className="sl-calcBox">
          { item.lrnPrgsStsCd === 'LPSC01' && <span className="ico ico-effort"></span>}
          { item.lrnPrgsStsCd === 'LPSC02' && <span className="ico ico-def"></span>}
          { item.lrnPrgsStsCd === 'LPSC03' && <span className="ico ico-enough"></span>}
          { item.lrnPrgsStsCd === 'LPSC04' && <span className="ico ico-nice"></span>}
          <img
            src={`${item.stgImgFilePath}${item.stgImgFileNm}`}
            alt={item.stgImgFileNm}
          />
        </div>
      </A>
      <div className="sl-txtBox">
        <p className="sl-txtBox_txt">
          {item.stgNm}
        </p>
        <div className="sl-txtBox_date">
          <div className="concept_tip">
            <A
              style={{ cursor: 'pointer' }}
              onClick={(e) => handleClick(e, item)}
            >
              {t("LC_04_01.msg019")}
            </A>
            {
              (videoMsg && btnType === 'video') && (
                item.lastStgYn !== "Y" && item.defaultStgCdYN !== 'Y'
                  ? <></>
                  : (
                    <div className="tooltip-def tooltipBox active">
                      <p>
                        <Trans t={t}>
                          LC_04_01.msg021
                        </Trans>
                        <button
                          className="btn-closeTooltip btn-close-tooltip"
                          onClick={() => handleMessage('video')}
                        />
                      </p>
                    </div>
                  )
              )
            }
          </div>
          <div className="wsDwon_wrap">
            {
              (info.channelCode === TYPE.CHANNEL.GLOBAL01 && item.workSheetYn === 'Y') && (
                <A onClick={() => handleWorkSheet(item)}>
                  <button type="button">{t("LC_05_07_01.msg023")}</button>
                </A>
              )
            }
            {
              ((worksheetMsg && btnType === 'worksheet') && item.workSheetYn === 'Y') && (
                item.lastStgYn !== "Y" && item.defaultStgCdYN !== 'Y'
                  ? <></>
                  : (
                    <div className="tooltip-def tooltipBox active">
                      <p>
                        <Trans t={t}>
                          LC_04_01.msg022
                        </Trans>
                        <button
                          className="btn-closeTooltip btn-close-tooltip"
                          onClick={() => handleMessage('worksheet')}
                        />
                      </p>
                    </div>
                  )
              )
            }
          </div>
        </div>
      </div>
      {
        (item.lastStgYn === "Y" && lastMsg && !btnType) && (
          <div id="last" className="tooltip-def tooltipBox type4 active">
            <p>
              <Trans t={t}>
                LC_04_01.msg017
              </Trans>
              <button
                onClick={() => handleMessage('last')}
                className="btn-closeTooltip btn-close-tooltip"
              />
            </p>
          </div>
        )
      }
      {
        (item.bgnStgCd && aiMsg) && (
          <div id="ai" className="tooltip-def tooltipBox type4 active">
            <p>
              <Trans t={t}>
                LC_04_01.msg018
              </Trans>
              <button
                className="btn-closeTooltip btn-close-tooltip"
                onClick={() =>  handleMessage('ai')}
              />
            </p>
          </div>
        )
      }
    </li>
  )
}

export default StageItem;